<template>
    <v-container
            fill-height
            fluid
            grid-list-xl>
        <v-layout wrap>
            <v-flex xs12 sm6 md9>
                <material-card class="mx-1"
                               color="orange"
                               :title="question.content">
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-text-field
                                :append-icon="search?'mdi-close':'mdi-magnify'"
                                :append-icon-cb="() => (search = '')"
                                @keydown.native.escape="search=''"
                                class="mr-4 mt-2 purple-input"
                                label="Search..."
                                hide-details
                                color="purple"
                                style="flex-grow: 0 !important;"
                                v-model="search"/>
                    </div>
                    <v-data-table
                            :headers="headers"
                            :items="user_choices"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :total-items="totalUserChoices">
                        <template v-slot:items="props">
                            <td class="text-xs-center">{{ props.item.sender_id }}</td>
                            <td class="text-xs-center">{{ props.item.question_content }}</td>
                            <td class="text-xs-center">{{ props.item.choice_content }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>
            <v-flex xs12 sm6 md3>
                <material-card class="mx-1"
                               color="orange"
                               title="Stats">
                    <chartist v-if="data.count > 0 && typeof data.count !=='undefined'"
                            :data="data"
                            :options="options"
                            :responsive-options="responsiveOptions"
                            type="Pie"/>
                    <p v-if="!(data.count > 0 && typeof data.count !=='undefined')" class="text-xs-center">No data available</p>
                </material-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                :color="snackbar.color"
                bottom
                right
                v-model="snackbar.show"
                dark>
            <v-icon color="white"
                    class="mr-3">
                {{snackbar.icon}}
            </v-icon>
            <div>{{snackbar.message}}</div>
            <v-icon size="16"
                    @click="snackbar.show = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </v-container>
</template>
<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                search: '',
                totalUserChoices: 0,
                loading: true,
                pagination: {},
                rowsPerPageItems: [5, 10, 20, 50, 100],
                headers: [
                    {
                        text: 'Sender ID',
                        align: 'center',
                        sortable: false,
                        value: 'sender_id'
                    },
                    {
                        text: 'Question',
                        align: 'center',
                        value: 'question_content',
                        sortable: false
                    },
                    {
                        text: 'Choice',
                        align: 'center',
                        value: 'choice_content',
                        sortable: false
                    },
                ],
                question: {},
                user_choices: [],
                snackbar: {
                    color: '',
                    message: '',
                    show: false,
                    icon: ''
                },
                // Chart Config
                options: {
                    labelInterpolationFnc: function (value) {
                        return value[0]
                    },
                    plugins: [
                        this.$chartist.plugins.tooltip({
                            appendToBody: true,
                        })
                    ],
                    showLabel: false,
                },
                responsiveOptions: [
                    ['screen and (min-width: 640px)', {
                        chartPadding: 30,
                        labelOffset: 100,
                        labelDirection: 'explode',
                        labelInterpolationFnc: function (value) {
                            return value;
                        }
                    }],
                    ['screen and (min-width: 1024px)', {
                        labelOffset: 80,
                        chartPadding: 20
                    }]
                ],
                data: {},
            }
        },
        created() {
            let self = this
            self.fetchData()
        },
         watch: {
            params: {
                handler() {
                    let self = this
                    self.getUserChoicesByPagination(self.$route.params['token'], self.search, self.pagination.page, self.pagination.rowsPerPage)
                        .then((user_choices) => {
                            self.user_choices = user_choices.data.results
                            self.totalUserChoices = user_choices.data.total
                        })
                },
            }
        },
        computed: {
            params(v) {
                return {
                    ...this.pagination,
                    query: this.search
                };
            }
        },
        methods: {
            //Notify
            showSuccessNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'success',
                    message: message,
                    show: true,
                    icon: 'mdi-information-variant'
                }
            },
            showErrorNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'error',
                    message: message,
                    show: true,
                    icon: 'mdi-alert-circle-outline'
                }
            },
            async getQuestionById(question_id, survey_id) {
                return await axios.get('/api/question/' + question_id + '/', {
                    headers: {
                        Authorization: 'Bearer ' + survey_id
                    }
                })
            },
            async getUserChoiceStats(question_id, survey_id) {
                return await axios.get('/question-stats/?question_id=' + question_id , {
                    headers: {
                        Authorization: 'Bearer ' + survey_id
                    }
                })
            },
            fetchData() {
                let self = this
                self.getQuestionById(self.$route.params['id'], self.$route.params['token'])
                    .then((question) => self.question = question.data)
                    .then(()=>self.getUserChoiceStats(self.$route.params['id'], self.$route.params['token']))
                    .then((stats)=>self.data = stats.data)
                    .then(() => self.getUserChoicesByPagination(self.$route.params['token'], self.search, self.pagination.page, self.pagination.rowsPerPage))
                    .then((user_choices) => {
                        self.user_choices = user_choices.data.results
                        self.totalUserChoices = user_choices.data.total
                    })
                    .catch((error) => self.showErrorNotify('Have some error:' + error))
            },
            async getUserChoicesByPagination(token, search, page, page_size) {
                let self = this
                let url = '/api/user-choice/?question='+self.$route.params['id']
                if (search)
                    url = url + '&search=' + search
                if (page)
                    url = url + '&page=' + page
                if (page_size)
                    url = url + '&page_size=' + page_size
                return await axios.get(url, {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                })
            },
        }
    }
</script>

<style lang="scss">
    .ct-tooltip {
        position: absolute;
        display: inline-block;
        min-width: 5em;
        padding: 8px 10px;
        background: #383838;
        color: #fff;
        text-align: center;
        pointer-events: none;
        z-index: 100;
        transition: opacity .2s linear;

        // Arrow
        &:before {
            position: absolute;
            bottom: -14px;
            left: 50%;
            border: solid transparent;
            content: ' ';
            height: 0;
            width: 0;
            pointer-events: none;
            border-color: rgba(251, 249, 228, 0);
            border-top-color: #383838;
            border-width: 7px;
            margin-left: -8px;
        }

        &.hide {
            display: block;
            opacity: 0;
            visibility: hidden;
        }
    }

</style>